import { colorsPalettes } from "@similarweb/styles";

const WIZARD_MODAL_MIN_PADDING = 32;
const WIZARD_MODAL_BORDER_WIDTH = 0;

export const WIZARD_MODAL_PADDING = (WIZARD_MODAL_MIN_PADDING + WIZARD_MODAL_BORDER_WIDTH) * 2;

export const WIZARD_MODAL_STYLES = {
    content: {
        padding: 0,
        borderRadius: 10,
        borderWidth: `${WIZARD_MODAL_BORDER_WIDTH}px`,
        boxShadow: "rgba(14, 30, 62, 0.12) 0px 18px 34px 0px",
        width: `calc(100% - ${WIZARD_MODAL_MIN_PADDING}px)`,
        height: `calc(100% - ${WIZARD_MODAL_MIN_PADDING}px)`,
        maxWidth: 1376,
        maxHeight: 836,
        overflow: "hidden",
        outline: "none",
    },
    overlay: {
        backgroundColor: colorsPalettes.bluegrey[100],
    },
};
